var tooltips = require('comp/tooltip');

;(function(){
  window.lp.editor.panel = window.lp.editor.panel || {};

  window.lp.editor.panel.AutoLayoutControl = function(type, uiBinding) {
    var _autoLayoutUIBinding = uiBinding
      .mkNamespacedVersion('autoLayout')
      .subscribeDomainEvents({
        runAutoLayout: function(ev) {
          window.lp.pom.AutoLayout.run(ev.runOn);
        }
      });

    var _button = function(runOn) {
      var buttonLabel = runOn === 'page' ?
        'All Sections' :
        'Section';

      return new window.jui.Button({
        label  : buttonLabel,
        id     : 'auto-layout-page-button',
        action : function() {
          _autoLayoutUIBinding.onNext({
            type  : 'runAutoLayout',
            runOn : runOn
          });
        }
      });
    };

    var _buttons = function() {
      
      var isPageSection = type === 'page section';
      var baseClass = 'help-button tip-auto-layout';
      var tooltipClass = isPageSection ? baseClass + "-section" : baseClass;

      var autoLayoutButtons = new window.jui.Component({attributes: {className: 'auto-layout-buttons'}});

      var tooltipElm = new Element('a', {
        id: 'text-editor-dynamic-help',
        class: tooltipClass
        }
      );

      if(isPageSection) {
        autoLayoutButtons.insert(_button('page section'));

        autoLayoutButtons.insert(new Element('div', {class: 'auto-layout-button-divider'}))
          .update('or');

        tooltips.attachTooltips([{
          selector: ".tip-auto-layout-section",
          copy: "Layout Assistant will do its best to organize your page to be mobile optimized.",
          target: tooltipElm,
          disabled: false,
          color: 'white',
          size: 'small',
          position: 'fixed'
        }]);
      }

      autoLayoutButtons.insert(_button('page'));

      autoLayoutButtons.insert(tooltipElm);

      return autoLayoutButtons;
    };

    this.view = function() {

      var autoLayoutPanel = new window.jui.CollapsiblePanel({
        title:'Layout Assistant',
        attributes: {
          className: 'collapsible-panel panel-root-layout-assistant'
        }
      });

      autoLayoutPanel.insert(new Element('div', {class: 'auto-layout-label'}));

      var autoLayoutTxt = new Element('div')
        .addClassName('auto-layout-txt')
        .update('Apply Layout Assistant to:');

      autoLayoutPanel.insert(autoLayoutTxt);

      autoLayoutPanel.insert(_buttons());
      return autoLayoutPanel;
    };
  };
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/panel/autolayout-properties-panel.js
// module id = 1044
// module chunks = 0